import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

import { FilterFieldAccountSitesComponent } from './filter-field-account-sites.component';
import { IconsModule } from 'src/app/project/components/icons/icons.module';
import { IconModule } from 'src/app/project/components/icon/icon-module';

@NgModule({
  declarations: [FilterFieldAccountSitesComponent],
  imports: [CommonModule, PipesModule, IconsModule, IconModule],
  exports: [FilterFieldAccountSitesComponent],
})
export class FilterFieldAccountSitesModule {}
